import type { ChartFiltersUnion } from 'shared/types/analytics';
import { chartRuntimeToChartResult } from '../adapters/chartRuntimeToChartResult';
import { getChartDefinition, type ChartId } from '../catalog/chartCatalog';
import type { ChartResult } from '../catalog/types';
import { useCurrentUserInProject } from 'store/user';
import { IDLE_CHART_RESULT } from './chartResultUtils';
import { useChartWithRefresh } from './useChartWithRefresh';
import type { ChartRuntime } from 'views/analytics/types';

export function useCatalogChartBundle<F>(
  id: ChartId,
  runtime: ChartRuntime<F>
): {
  result: ChartResult;
  runtime: ChartRuntime<ChartFiltersUnion>;
} {
  const definition = getChartDefinition(id);
  if (!definition) {
    throw new Error(`Unknown chart: ${id}`);
  }
  const user = useCurrentUserInProject();
  const chartRuntime = runtime as ChartRuntime<ChartFiltersUnion>;
  const result = useChartWithRefresh(id, definition, (enabled) => {
    if (!enabled) {
      return IDLE_CHART_RESULT;
    }
    return chartRuntimeToChartResult(chartRuntime, user);
  });

  return { result, runtime: chartRuntime };
}
